import { render } from "./ProjectLayoutPage.vue?vue&type=template&id=09b6d961&ts=true"
import script from "./ProjectLayoutPage.vue?vue&type=script&lang=ts"
export * from "./ProjectLayoutPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__